import {SidebarMain} from '@sollapay/ui/components';
import {NavigationHistoryProvider} from '@sollapay/web-core';
import {Outlet} from 'react-router-dom';

import {RequiredProfileGate} from '@/features/account-settings';

import {Footer} from './Footer';
import {GuestSidebar} from './GuestSidebar';

import type {FC} from 'react';

/** The guest shell mounts none of the members-only realtime and firm requests. */
export const GuestLayout: FC = () => (
  <NavigationHistoryProvider>
    <GuestSidebar>
      <SidebarMain className="overflow-hidden">
        <Outlet />
        <Footer />
      </SidebarMain>
    </GuestSidebar>
    <RequiredProfileGate isGuest />
  </NavigationHistoryProvider>
);
